import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=4a1ad2d1&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ad2d1",
  null
  
)

export default component.exports